<template>
<div class="reportList padding-20 bgc box-shadow">
    <div class="filters">
        <div class="add">
            <el-button v-if="permission.btnList.indexOf('A020201')==-1" type="primary" @click="handleAdd">发布报告</el-button>
        </div>
        <div class="search">
            <el-select v-model="param.status" placeholder="全部状态" class="condition" clearable>
                <el-option v-for="item in typeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
            </el-select>
            <el-input v-model="param.reportname" placeholder="请输入商品名称" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="reportname" label="报告标题" width="400" class-name="title">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img :src="scope.row.coveratturlid" :alt="scope.row.reportname">
                        <div class="imageText-summary">
                            <div class="textBox">
                                <div class="text">
                                    <span class="recommon" v-if="scope.row.isinnerrecomm === 1">推荐</span>{{ scope.row.reportname }}
                                </div>
                            </div>
                            <div class="price">
                                <span v-if="scope.row.feetype === 1">免费</span>
                                <span v-else>￥{{scope.row.saleprice}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="datetime" label="发布时间" class-name="center" width="180"></el-table-column>
            <el-table-column prop="ordersucccount" label="购买次数" class-name="center"></el-table-column>
            <el-table-column prop="zmstatus" label="转码" class-name="center">
                <template slot-scope="scope">
                    <div class="imgStatus">
                        <span v-if="scope.row.zmstatus === 0" class="noTranscoding">转码中</span>
                        <span v-if="scope.row.zmstatus === 1" class="transcoding">转码完成</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="上架状态" class-name="center" width="116">
                <template slot-scope="scope">
                    <span :class='{"state30":scope.row.status === 30,"state1":scope.row.status === 1,"state11":scope.row.status === 11, "state0": scope.row.status === 0, "state10": scope.row.status === 10, "state31": scope.row.status === 31}'>·{{scope.row.statusname}}</span>
                    <el-tooltip class="item" effect="dark" :content="scope.row.state" placement="top" v-if="scope.row.stateCode === 11">
                        <!-- 这里写审核失败的原因 -->
                        <span>失败原因</span>
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="操作" label-class-name="tr" width="260px">
                <template slot-scope="scope">
                    <div class="tr">
                        <!-- 已上架 -->
                        <div v-if="scope.row.status === 30">
                            <span @click="handleEdit(scope.row)" v-if="permission.btnList.indexOf('A020202')==-1">编辑</span>
                            <span v-if="permission.btnList.indexOf('A020202')==-1">|</span>
                            <span @click="handleLowerShelf(scope.row)" v-if="permission.btnList.indexOf('A020204')==-1">下架</span>
                            <span v-if="permission.btnList.indexOf('A020204')==-1">|</span>
                            <Share :row="scope.row"></Share>
                            <span @click="handleDel(scope.row)" v-if="permission.btnList.indexOf('A020209')==-1">删除</span>
                            <span v-if="permission.btnList.indexOf('A020209')==-1">|</span>
                            <span>
                                <el-dropdown>
                                    <span class="el-dropdown-link">
                                        <el-button type="text" size="small">更多</el-button>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="discounts(scope.row)">优惠码</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleNameListMgt(scope.row)" v-if="permission.btnList.indexOf('A020210')==-1">名单管理</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleDataAnalysis(scope.row)">数据分析</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleRecommond(scope.row)" v-if="permission.btnList.indexOf('A020207')==-1 && (scope.row.isinnerrecomm === 2 || scope.row.isinnerrecomm === 0)">加入推荐</el-dropdown-item>
                                        <el-dropdown-item @click.native="cancelRecommond(scope.row)" v-if="permission.btnList.indexOf('A020208')==-1 && scope.row.isinnerrecomm === 1">取消推荐</el-dropdown-item>
                                        <!-- <el-dropdown-item @click.native="cancelRecommond(scope.row)" v-if="permission.btnList.indexOf('A020208')==-1 && scope.row.isinnerrecomm === 0">暂不选择</el-dropdown-item> -->
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </span>
                        </div>
                        <!-- 已下架 -->
                        <div v-if="scope.row.status === 31">
                            <span @click="handleEdit(scope.row)" v-if="permission.btnList.indexOf('A020202')==-1">编辑</span>
                            <span v-if="permission.btnList.indexOf('A020202')==-1">|</span>
                            <span @click="handleUpperShelf(scope.row)" v-if="permission.btnList.indexOf('A020203')==-1">上架</span>
                            <span v-if="permission.btnList.indexOf('A020203')==-1">|</span>
                            <Share :row="scope.row"></Share>
                            <span @click="handleDel(scope.row)" v-if="permission.btnList.indexOf('A020209')==-1">删除</span>
                            <span v-if="permission.btnList.indexOf('A020209')==-1">|</span>
                            <span>
                                <el-dropdown>
                                    <span class="el-dropdown-link">
                                        <el-button type="text" size="small">更多</el-button>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="discounts(scope.row)">优惠码</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleNameListMgt(scope.row)" v-if="permission.btnList.indexOf('A020210')==-1">名单管理</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleDataAnalysis(scope.row)">数据分析</el-dropdown-item>
                                        <!-- <el-dropdown-item @click.native="handleRecommond(scope.row)" v-if="permission.btnList.indexOf('A020207')==-1 && scope.row.isinnerrecomm === 2">加入推荐</el-dropdown-item>
                                        <el-dropdown-item @click.native="cancelRecommond(scope.row)" v-if="permission.btnList.indexOf('A020208')==-1 && scope.row.isinnerrecomm === 1">取消推荐</el-dropdown-item> -->
                                        <!-- <el-dropdown-item @click.native="cancelRecommond(scope.row)" v-if="permission.btnList.indexOf('A020208')==-1 && scope.row.isinnerrecomm === 0">暂不选择</el-dropdown-item> -->
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </span>
                        </div>
                        <!-- 待上架 -->
                        <div v-if="scope.row.status === 10">
                            <span @click="handleEdit(scope.row)" v-if="permission.btnList.indexOf('A020202')==-1">编辑</span>
                            <span v-if="permission.btnList.indexOf('A020202')==-1">|</span>
                            <span @click="handleDel(scope.row)" v-if="permission.btnList.indexOf('A020209')==-1">删除</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
</div>
</template>

<script>
import {getReportList, editReportStatus, delReport, editReportRecommend} from 'api/api'
import {reportMgtCode} from 'api/enumCode'
import Share from 'base/share/share'
import Page from 'base/page/page'
import {promiseUrlToQRCode} from 'common/js/tools'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'reportList',
    data() {
        return {
            logo: require('@/common/images/index/logo.png'),
            statusList: reportMgtCode.status,
            total: 0,
            param: {
                status: '',
                reportname: ''
            },
            tableData: [],
            typeList: [
                {code: '', name: '全部状态'},
                {code: '10', name: '待上架'},
                {code: '30', name: '已上架'},
                {code: '31', name: '已下架'}
            ]
        }
    },
    mounted() {
        this._getList()
    },
    beforeRouteEnter (to, from, next) {
        next(v => {
            if (v.$route.query.refresh === '1') {
                let page = {
                    page: 1,
                    pageSize: 10
                }
                v.setPage(page)
                v.$refs.page.pagination.page = 1
                v._getList()
            } else if (v.$route.query.refresh === '0') {
                v._getList()
            }
        })
    },
    methods: {
        handleQuery() {
            this._getList()
        },
        handleEdit(row) {
            this.$router.push({name: 'ReportEdit', query: {id: row.innerid, page: this.$refs.page.page.page}})
        },
        handleNameListMgt(row) {
            this.$router.push({name: 'ReportNameList', query: {id: row.innerid}})
        },
        handleDataAnalysis(row) {
            this.$router.push({name: 'ReportDataAnalysis', query: {id: row.innerid, status: row.status}})
        },
        handleAdd() {
            if (this.shop.authstatus === 0) {
                this.$confirm('该功能需要在开通企业版或者单独工具基础上方可使用，建议尽快购买，购买后可继续使用该功能', '提示', {
                    confirmButtonText: '去购买',
                    cancelButtonText: '取消'
                }).then(() => {
                    // 去购买
                    this.$router.push({name: 'OrderService'})
                }).catch(() => {
                    // 取消
                })
            } else {
                this.$router.push({name: 'ReportEdit'})
            }
        },
        // 删除
        handleDel(row) {
            this.$confirm(`确定将该商品删除吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                delReport({
                    data: {innerid: row.innerid, status: '100'},
                    success: data => {
                        if (data.code === '000') {
                            this.$message({
                                type: 'success',
                                message: '删除成功'
                            })
                            this._getList()
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 上架
        handleUpperShelf(row) {
            this.$confirm(`确定上架？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                delReport({
                    data: {innerid: row.innerid, status: '30'},
                    success: data => {
                        this.$message({
                            type: 'success',
                            message: '上架成功'
                        })
                        this._getList()
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 下架
        handleLowerShelf(row) {
            this.$confirm(`确定需要将该商品下架吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                delReport({
                    data: {innerid: row.innerid, status: '31'},
                    success: data => {
                        console.log(data)
                        this.$message({
                            type: 'success',
                            message: '下架成功'
                        })
                        this._getList()
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 加入推荐
        handleRecommond(row) {
            this.$confirm(`确定要将该商品加入推荐？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                editReportRecommend({
                    data: {innerid: row.innerid, isinnerrecomm: '1'},
                    success: data => {
                        if (data.code === '000') {
                            this._getList()
                            this.$message({
                                type: 'success',
                                message: '加入推荐成功'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 取消推荐
        cancelRecommond(row) {
            this.$confirm(`确定要将该商品取消推荐？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                editReportRecommend({
                    data: {innerid: row.innerid, isinnerrecomm: '2'},
                    success: data => {
                        if (data.code === '000') {
                            this._getList()
                            this.$message({
                                type: 'success',
                                message: '取消推荐成功'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 优惠码
        discounts(row) {
            this.$router.push({name: 'CouponList', query: {id: row.innerid, kmctype: 2}})
        },
        _getList() {
            this.setLoading(true)
            getReportList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    data.data.forEach(obj => {
                        promiseUrlToQRCode(obj.shareurl, obj.coveratturlid).then(
                            function(data) {
                                obj.subject = obj.reportname
                                obj.qrShare = data
                            },
                            function(reason, data) {
                                console.log('二维码生成失败：', reason)
                            }
                        )
                    })
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    filters: {
        status: function (value) {
            for (let i = 0; i < reportMgtCode.status.length; i++) {
                if (value === reportMgtCode.status[i].code) {
                    return reportMgtCode.status[i].name
                }
            }
            return value
        },
        feetype: function (value) {
            for (let i = 0; i < reportMgtCode.feetype.length; i++) {
                if (value === reportMgtCode.feetype[i].code) {
                    return reportMgtCode.feetype[i].name
                }
            }
            return value
        }
    },
    watch: {},
    computed: {
        status () {
            return function(value) {
                for (let i = 0; i < reportMgtCode.status.length; i++) {
                    if (value === reportMgtCode.status[i].code) {
                        return reportMgtCode.status[i].cls
                    }
                }
                return value
            }
        },
        feetype () {
            return function(value) {
                for (let i = 0; i < reportMgtCode.feetype.length; i++) {
                    if (value === reportMgtCode.feetype[i].code) {
                        return reportMgtCode.feetype[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters([
            'page',
            'user',
            'permission',
            'shop'
        ])
    },
    components: {
        Page, Share
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.reportList {
    .tr{
        font-size: 12px;
        &>div>span{
            color: #409EFF;
            margin-left: 10px;
            cursor: pointer;
        }
        .el-dropdown-link{
            margin-left: 0;
            span{
                margin-left: 0;
            }
        }
    }
    .center{
        text-align: center;
    }
    .state30{
        color: #67C23A;
    }
    .state1{
        color: #E6A23C;
    }
    .state11{
        color: #F56C6C;
        .el-icon-info{
            color: #C0C4CC;
        }
    }
    .state31{
        color: #909399;
    }
    .state0{
        color: #606266;
    }
    .state10{
        color: #409EFF;
    }
    .state12{
        color: #909399;
    }
    .result-list{
        .el-table__row{
            height: 100px;
        }
        .imageText{
            display: flex;
            width: 100%;
            height: 100%;
            img{
                min-width: 106px;
                max-width: 106px;
                height: 60px;
            }
            .imageText-summary{
                .textBox{
                    width: 280px;
                    height: 40px;
                    line-height: 20px;
                    overflow: hidden;
                    .text{
                        float: right;
                        /* "margin-left"要等于".wrap::before"的宽度 */
                        margin-left: -10px;
                        width: 280px;
                        word-break: break-all;
                        // font-size: 0.48rem;
                    }
                    &::before {
                        float: left;
                        content: '';
                        width: 10px;
                        height: 100%;
                    }
                    &::after {
                        float: right;
                        content: "...";
                        /* 行高与".wrap"设置的一致即可 */
                        height: 40px;
                        line-height: 20px;
                        /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                        width: 37px;
                        margin-left: -30px;
                        /* 移动省略号位置 */
                        position: relative;
                        left: 96%;
                        bottom: 20px;
                        font-weight: 600;
                        padding-right: 1px;
                        background: #fff;
                        transition: all 0.5s;
                    }
                    .recommon{
                        color: #fff;
                        background: #E6A23C;
                        display: inline-block;
                        width: 36px;
                        height: 16px;
                        line-height: 16px;
                        text-align: center;
                        margin-right: 5px;
                        font-size: 12px;
                    }
                }
                .price{
                    // margin-left: 5px;
                    color: #F56C6C;
                }
            }
        }
        .el-table__row:hover{
            .textBox{
                &::after{
                    background: #F5F7FA;
                }
            }
        }
        .imgStatus{
            .noTranscoding{
                color: #E6A23C;
            }
            .transcoding{
                color: #67C23A;
            }
        }
        img{
            width: 100px;
            flex-grow: 0;
            height: 60px;
        }
        .icon{
            margin-left: 10px;
            width: 14px;
            height: 14px;
        }
    }
    .el-table{
        .title{
            .cell{
                padding: 0;
                margin-left: 5px;
            }
        }
    }
    .result-list .imageText .imageText-summary div:nth-child(1){
        margin-bottom: 0;
    }
}
</style>
